<div class="qq-summary" [appScrollIntoView]="true">
  <div class="qq-summary__header">
    <h1>Your Quote</h1>
  </div>

  <div class="qq-summary__result" *ngIf="quote.result.error">
    <div [innerHtml]="quote.result.error"></div>
  </div>

  <div class="qq-summary__block" [class.col]="page === 'summary-1'" *ngIf="!quote.result.error">
    <div class="columns">
      <div class="apg-panel qq-complete__block__quote">
        <app-apg-quick-quote-result [quote]="quote" [quickQuote]="quickQuote" [page]="page">
        </app-apg-quick-quote-result>
        <div class="summary__buttons">
          <ion-button (click)="continue.emit()">
            Purchase
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </ion-button>
        </div>
        <a href="javascript:void(0)" (click)="changeQuote()">Change Quote</a>
      </div>
      <div class="notes">
        <app-apg-quick-quote-notes [quickQuote]="quickQuote"></app-apg-quick-quote-notes>
      </div>
  </div>
</div>
